import { render, staticRenderFns } from "./OnlineDiscussDetail.vue?vue&type=template&id=55e57c76&scoped=true&"
import script from "./OnlineDiscussDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineDiscussDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=55e57c76&scoped=true&lang=css&"
import style1 from "./OnlineDiscussDetail.vue?vue&type=style&index=1&id=55e57c76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e57c76",
  null
  
)

export default component.exports